/**
 * Shared constants used across all environment configurations.
 * These values are not environment-specific and should remain consistent
 * across dev, test, prod, and other environments.
 */

// ============================================================================
// OAuth / Authentication Constants
// ============================================================================

export const CLIENT_ID_BROWSER = 'web_app_user_app';
export const CLIENT_ID_NATIVE = 'native_app_user_app';
// Neutral placeholder; consumers fill `client_id` at runtime from the platform
// (isCordova ? CLIENT_ID_NATIVE : CLIENT_ID_BROWSER), same as the other dynamic params below.
export const CLIENT_ID_PARAM = { client_id: '' };
export const RESPONSE_TYPE_PARAM = { response_type: 'code' };
export const REDIRECT_URI_PARAM = { redirect_uri: '' };

// PKCE parameters (no client secret needed)
export const GRANT_TYPE_PARAM = { grant_type: 'authorization_code' };
export const GRANT_TYPE_REFRESH_PARAM = { grant_type: 'refresh_token' };
export const CODE_PARAM = { code: '' };
export const REFRESH_TOKEN_PARAM = { refresh_token: '' };
export const REVOKE_TOKEN_PARAM = { token: '' };

// ============================================================================
// Query Parameter Arrays
// ============================================================================

export const SIGN_IN_QUERY_PARAMS = [
  RESPONSE_TYPE_PARAM,
  CLIENT_ID_PARAM,
  REDIRECT_URI_PARAM
];

export const AUTHORIZATION_QUERY_PARAMS = [
  GRANT_TYPE_PARAM,
  CLIENT_ID_PARAM,
  REDIRECT_URI_PARAM,
  CODE_PARAM
];

export const REFRESH_TOKENS_QUERY_PARAMS = [
  GRANT_TYPE_REFRESH_PARAM,
  CLIENT_ID_PARAM,
  REFRESH_TOKEN_PARAM
];

export const REVOKE_TOKEN_QUERY_PARAMS = [
  CLIENT_ID_PARAM,
  REVOKE_TOKEN_PARAM
];